<template>
  <v-layout
    column
    fill-height
    class="mb-3"
  >
    <v-card-title class="mb-0 pb-0" v-if="showButtons">
      <v-btn icon :to="{ name: routeName.WAREHOUSE }" active-class="">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
         v-if="hasRole('super-admin') || hasRole('admin')"
         class="primary"
         @click="emptyWarehouse"
      >
        {{ $t('EMPTY_WAREHOUSE') }}
      </v-btn>
      <v-tooltip bottom v-if="can('edit warehouses')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
             icon
             v-bind="attrs"
             v-on="on"
             @click="editWarehouse"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('EDIT') }}</span>
      </v-tooltip>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="deleteWarehouse">
              <v-icon>block</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('DELETE') }}</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-card-title class="mt-1 pt-0">
    </v-card-title>
    <v-tabs
      :value="value"
      @change="tabChanged"
      centered
      grow
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab dark href="#warehouse">
          {{ $t('WAREHOUSE') }}
        </v-tab>
        <v-tab dark href="#warehouse-product">
          {{ $t('PRODUCTS') }}
        </v-tab>
        <v-tab dark href="#warehouse-load">
          {{ $t('WAREHOUSES_LOAD') }}
        </v-tab>
        <v-tab dark href="#warehouse-unload">
          {{ $t('WAREHOUSES_UNLOAD') }}
        </v-tab>
        <v-tab dark href="#warehouse-transfer">
          {{ $t('WAREHOUSES_TRANSFER') }}
        </v-tab>
    </v-tabs>
  </v-layout>
</template>
<script>

  export default {
    name: 'WarehouseTabs',
    props: {
      warehouse: Object,
      value: String,
      showButtons: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      emptyWarehouse() {
        this.$emit('empty');
      },

      deleteWarehouse() {
        this.$emit('delete');
      },

      editWarehouse() {
        this.$emit('edit');
      },

      tabChanged(tab) {
        this.$emit('input', tab);
      },

    },
  };
</script>
